import { useEffect } from 'react'
import { Outlet, useLocation, useParams } from 'react-router-dom'
import { HeaderWrapper } from './components/header'
import { RightToolbar } from '../partials/layout/RightToolbar'
import { ScrollTop } from './components/scroll-top'
import { Content } from './components/content'
import { Sidebar } from './components/sidebar'
import { PageDataProvider } from './core'
import { reInitMenu } from '../helpers'
import { ThemeModeProvider } from '../partials'
import ClientList from '../../app/pages/TPVAdmin/ClientList'
import { TotalTPVList } from '../../app/pages/TPVAdmin/TotalTPVList'
import { TpvAdminDashboardWrapper } from '../../app/pages/TPVAdmin/DashboardWrapper'
import "../../app/shared-css/Global.css"
import { useLocalStorage } from '../../utils/useLocalStorage'
import { urlPath } from '../../utils/GlobalConstants'

const MasterLayout = ({ component: ContentComponent }: any) => {
  console.log("inmasterlayout")
  const location = useLocation()
  useEffect(() => {
    reInitMenu()
  }, [location.key])
  const { removeItem } = useLocalStorage()

  useEffect(() => {
    if (!location.pathname.includes(urlPath.tpvRecording)) {
      removeItem(urlPath.tpvRecording)
    }
    if (!location.pathname.includes(urlPath.salesChannel)) {
      removeItem(urlPath.salesChannel)
    }
  }, [location])

  return (
    <PageDataProvider>
      <ThemeModeProvider>
        <div className='d-flex flex-column flex-root app-root' id='kt_app_root'>
          <div className='app-page flex-column flex-column-fluid' id='kt_app_page'>
            <HeaderWrapper />
            <div className='app-wrapper flex-column flex-row-fluid' id='kt_app_wrapper'>
              <Sidebar />
              <div className='app-main flex-column flex-row-fluid' id='kt_app_main'>
                <div className='d-flex flex-column flex-column-fluid p-1'>
                  {/* <ToolbarWrapper /> */}
                  <Content>
                    {/* <TotalTPVList className='card-xxl-stretch mb-5 mb-xl-8'/> */}
                    <ContentComponent />
                    <Outlet />
                  </Content>
                </div>
                {/* <FooterWrapper /> */}
              </div>
            </div>
          </div>
        </div>

        {/* begin:: Drawers */}
        {/* <ActivityDrawer /> */}
        <RightToolbar />
        {/* <DrawerMessenger /> */}
        {/* end:: Drawers */}

        {/* begin:: Modals */}
        {/* <InviteUsers />
        <UpgradePlan /> */}
        {/* end:: Modals */}
        {/* <ScrollTop /> */}
      </ThemeModeProvider>
    </PageDataProvider>
  )
}

export { MasterLayout }
